'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M226.4 11.9c13.5 16.5 29.7 38.3 45.3 64.2 5.2-6.8 10-12.8 14.2-17.9 10.2-12.2 21-23 32.2-34.2 .6-.6 1.3-1.3 1.9-1.9 11.6 11.6 24.2 24.2 34.7 36.9 10.3 12.4 24 30.3 37.7 52.4 27.2 43.9 55.6 106.4 55.6 176.6 0 123.7-100.3 224-224 224S0 411.7 0 288c0-91.1 41.1-170 80.5-225 19.9-27.7 39.7-49.9 54.6-65.1 13.4-13.8 27.2-25.7 41.8-38 17.7 16.6 34 33.1 49.5 52.1zm63.5 122.4l-22.6 36-19.1-38c-19-37.6-41.3-68.5-58.9-90.1-5.2-6.4-10-12-14.2-16.6-1.8 1.7-3.6 3.6-5.6 5.6-13.6 14-31.8 34.3-49.9 59.6-36.6 51-71.5 120.1-71.5 197 0 97.2 78.8 176 176 176s176-78.8 176-176c0-57.7-23.6-111.3-48.4-151.4-11.3-18.3-22.7-33.4-31.6-44.4-8.5 10.5-19.3 24.8-30.2 42.1zM225.7 416c-63.2 0-113.7-40.6-113.7-109.2 0-65.6 63.2-114.8 63.2-114.8 5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8 25.3 46.2 14 105-28.1 134.4-21.1 14-43.5 21-68.8 21z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;